import '../styles/spinner.scss';

export function Spinner() {
  return (
    <div className="spinner">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}

export function Ellipsis() {
  return (
    <div className="loading-ellipsis">
      <div></div>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );
}
